// ============================================================================
// vpn/vpnErrors.ts — человеческие тексты ошибок VPN (без кодов и жаргона).
// Один источник для экрана подключений и «Расширенных»: пользователь видит
// понятную причину и что делать, техническая деталь уходит в журнал.
// ============================================================================

import { errorCode, friendlyError, isNotFoundError, isPermissionDeniedError } from '@/lib/errors';

export type VpnAction = 'connect' | 'disconnect' | 'config' | 'list';

export function vpnErrorMessage(e: unknown, action: VpnAction): string {
  if (isPermissionDeniedError(e)) {
    if (action === 'list') return 'Нет доступа к VPN. Обратитесь к администратору — он откроет доступ.';
    return action === 'connect'
      ? 'Нет доступа к этому подключению. Обратитесь к администратору.'
      : 'Нет доступа к настройкам этого подключения. Обратитесь к администратору.';
  }
  if (isNotFoundError(e)) {
    if (action === 'list') return 'Список подключений не найден. Обновите страницу.';
    return action === 'config'
      ? 'Подключение не найдено или доступ к нему закрыт. Обновите список.'
      : 'Подключение не найдено. Обновите список и попробуйте снова.';
  }
  const code = errorCode(e);
  const failedPrecondition = code === 9
    || (typeof code === 'string' && code.toLowerCase() === 'failed_precondition');
  if (failedPrecondition) {
    return 'Подключение пока не готово: администратор не завершил настройку. Попробуйте позже или обратитесь к администратору.';
  }
  return friendlyError(e);
}
